import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import type { ResolvedReleaseEntry, ResolvedReleaseStory } from 'fym-shared/src/releases/types';
import { TypedMemo } from '../../common/types';
import { WhatsNewStoryCard } from './WhatsNewStoryCard';
import { WhatsNewEntryRow } from './WhatsNewEntryRow';
import { whatsNewMessages as m } from './whatsNewMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the panel; each part uses its own slice of it */
import styles from './WhatsNew.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface Props {
  entries: ResolvedReleaseEntry[];
}

type StoryEntry = ResolvedReleaseEntry & { story: ResolvedReleaseStory };

/**
 * The panel body (design whats-new a1, a2): the story cards first, in the order of the answer,
 * then "Also in this version" with one card of plain rows. The card number is the position among
 * the story cards of this panel, not an id.
 */
const WhatsNewBodyComponent: React.FC<Props> = ({ entries }) => {
  const intl = useIntl();
  const stories = useMemo(() => entries.filter((entry): entry is StoryEntry => entry.story !== undefined), [entries]);
  const plain = useMemo(() => entries.filter((entry) => entry.story === undefined), [entries]);

  return (
    <div className={styles.body}>
      {stories.length > 0 && (
        <ul className={styles.list}>
          {stories.map((entry, index) => (
            <WhatsNewStoryCard key={entry.id} story={entry.story} index={index + 1} />
          ))}
        </ul>
      )}
      {plain.length > 0 && (
        <>
          <div className={styles.more}>{intl.formatMessage(m.more)}</div>
          <ul className={styles.rows}>
            {plain.map((entry) => (
              <WhatsNewEntryRow key={entry.id} entry={entry} />
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export const WhatsNewBody = TypedMemo(WhatsNewBodyComponent);
